import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';
// utils
import axios, { fetcher, endpoints } from 'src/utils/axios';

// ----------------------------------------------------------------------

export function useGetUsers() {
  const URL = endpoints.user.list;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  const response = data?.data;
  const memoizedValue = useMemo(
    () => ({
      users: response?.users || [],
      usersLoading: isLoading,
      usersError: error,
      usersValidating: isValidating,
      usersEmpty: !isLoading && !response?.users?.length,
    }),
    [response?.users, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export async function createUser(apiData) {
  const URL = endpoints.user.list;

  try {
    const { data } = await axios.post(endpoints.user.create, apiData);
    if (data.code === 200) {
      await mutate(URL);
    }
    return data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
}

export async function updateUser(apiData, id) {
  const URL = endpoints.user.list;
  try {
    const { data } = await axios.put(endpoints.user.update, apiData);
    if (data.code === 200) {
      await mutate(URL);
    }
    return data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
}
export async function changeStatus(apiData) {
  const URL = endpoints.user.list;
  try {
    const { data } = await axios.put(endpoints.user.changeStatus, apiData);
    if (data.code === 200) {
      await mutate(URL);
    }
    return data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
}
export async function deleteUser(userId) {
  const URL = endpoints.user.list;

  try {
    const { data } = await axios.delete(`${endpoints.user.delete}/${userId}`);
    if (data.code === 200) {
      console.log(data, 'working?');
      mutate(
        URL,
        (currentData) => {
          const currentUsers = currentData?.data?.users || [];
          const updatedUsers = currentUsers.filter((user) => user._id !== userId);
          return {
            ...currentData,
            data: {
              ...currentData.data,
              users: updatedUsers,
            },
          };
        },
        false
      );
    }

    return data;
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
}

export function useGetUserReport() {
  const URL = endpoints.user.report;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  const response = data?.data;
  const memoizedValue = useMemo(
    () => ({
      userReport: response || [],
      userReportLoading: isLoading,
      userReportError: error,
      userReportValidating: isValidating,
      userReportEmpty: !isLoading && !response?.users?.length,
    }),
    [response?.users, error, isLoading, isValidating]
  );

  return memoizedValue;
}
